import Organization from "@/models/Organization";

export default class OrganizationTransformer {
    transform (data) {
        return new Organization(data.id, data.name);
    }
}
